import { ApiBase } from "../../core/api-base";
import { Roles } from "../../constants/roles";

class DirectMaximizeReadTracker extends ApiBase {
    private readonly tracked = new Set<string>();

    public trackFromCard(card: HTMLElement | null): void {
        if (!(card instanceof HTMLElement)) return;
        const postId = card.dataset.postId ?? "";
        const boardId = card.dataset.boardId ?? "";
        if (!postId || !boardId) return;

        const key = `${boardId}:${postId}`;
        if (this.tracked.has(key)) return;
        this.tracked.add(key);

        void this.sendRead(boardId, postId);
    }

    private async sendRead(boardId: string, postId: string): Promise<void> {
        try {
            const response = await this.apiPost(`/api/v1/posts/${boardId}/${postId}/reads`, null, {
                noSpinner: true,
            });
            if (!response.ok) return;

            const data = (await response.json()) as { reads_count?: number };
            const count = data.reads_count;
            if (typeof count !== "number") return;

            document
                .querySelectorAll<HTMLElement>(`[data-post-id="${postId}"] [data-role="${Roles.READ_COUNT}"]`)
                .forEach((el) => {
                    el.textContent = String(count);
                });
        } catch {
            // network error — silently ignore
        }
    }
}

export const directMaximizeReadTracker = new DirectMaximizeReadTracker();
